<template>
  <section id="innova-startup-week-2023" class="text-justify">
    <br />
    <p v-html="$t('content')"></p>
    <b-carousel :indicator-inside="false">
      <b-carousel-item v-for="(img, i) in images" :key="i">
        <img class="w100" :src="getImgUrl(img)" alt="media-presence-1.png" />
      </b-carousel-item>
    </b-carousel>
  </section>
</template>
<script>
export default {
  name: "innova-startup-week-2023",
  data() {
    return {
      images: [
        "1697118874116",
        "1697118874360",
        "1697118874431",
        "1697118874639",
        "1697214404103",
      ],
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/news/innova-startup-week-2023/" +
        pic +
        ".jpg");
    },
  },
};
</script>
<i18n>
{
    "es": {
        "title": "Innova Startup Week 2023",
        "content": " Innova Startup Week es una instancia que busca conectar a importantes corporativos con startups de base tecnológica aplicadas a las industrias de Fintech-Insurtech, Experiencia Clientes-Retail, Excelencia Operacional, y otros. El mes pasado fuimos partícipes de esta gran oportunidad en la cual pudimos relacionarnos con empresas de alto nivel y cumplir el objetivo de la actividad, la cual buscaba “Generar un espacio de networking entre startups con grandes corporaciones, por medio de reuniones exploratorias organizadas por el equipo de Innova360 de acuerdo a los objetivos planteados por cada empresa. A su vez, lograr visibilidad de oportunidades comerciales y alianzas que faciliten una potencial expansión de las startups”.",
        "more":"Ver más"
    },
    "en": {
        "title": "Innova Startup Week 2023",
        "content": "Innova Startup Week is an event that seeks to connect important corporations with technology-based startups applied to the Fintech-Insurtech, Customer Experience-Retail, Operational Excellence, and other industries. Last month we were participants in this great opportunity in which we were able to interact with high-level companies and meet the objective of the activity, which sought to “Generate a networking space between startups with large corporations, through exploratory meetings organized by the Innova360 team according to the objectives set by each company. At the same time, achieve visibility of commercial opportunities and alliances that facilitate potential expansion of startups.”",
        "more":"See more"
    },
    "pt": {
        "title": "Innova Startup Week 2023",
        "content": "O Innova Startup Week é um evento que busca conectar importantes corporações com startups de base tecnológica aplicada aos setores Fintech-Insurtech, Customer Experience-Varejo, Excelência Operacional, entre outros. No mês passado participamos desta grande oportunidade em que pudemos interagir com empresas de alto nível e cumprir o objetivo da atividade, que buscava “Gerar um espaço de networking entre startups com grandes corporações, através de encontros exploratórios organizados pelo Innova360 equipe de acordo com os objetivos definidos por cada empresa. Ao mesmo tempo, obter visibilidade de oportunidades comerciais e alianças que facilitem a expansão potencial de startups.”",
        "more":"Ver mais"
    }
}
</i18n>
